type NarrativeItem = {
  id: string;
  title: string;
  type: 'story' | 'journey';
  created_at?: string;
  summary?: string;
};

type StoryLike = {
  id: string;
  title?: string;
  content?: string;
  member_ids?: string[];
  created_at?: string;
};

type JourneyLike = {
  id: string;
  title?: string;
  description?: string;
  member_ids?: string[];
  created_at?: string;
};

export function getLinkedNarrativesForMember(
  memberId: string,
  stories: StoryLike[] = [],
  journeys: JourneyLike[] = [],
): NarrativeItem[] {
  const linkedStories = (stories ?? [])
    .filter((story) => (story.member_ids ?? []).includes(memberId))
    .map((story) => ({
      id: story.id,
      title: story.title ?? 'Untitled story',
      type: 'story' as const,
      created_at: story.created_at,
      summary: story.content,
    }));

  const linkedJourneys = (journeys ?? [])
    .filter((journey) => (journey.member_ids ?? []).includes(memberId))
    .map((journey) => ({
      id: journey.id,
      title: journey.title ?? 'Untitled journey',
      type: 'journey' as const,
      created_at: journey.created_at,
      summary: journey.description,
    }));

  return [...linkedStories, ...linkedJourneys].sort((a, b) => {
    const aDate = a.created_at ? new Date(a.created_at).getTime() : 0;
    const bDate = b.created_at ? new Date(b.created_at).getTime() : 0;
    return bDate - aDate;
  });
}
